import numpad from './themes/numpad';

export default name => {
  const themes = { numpad };
  return themes[name] || numpad;
}


export const numpadStyles = {
  keys: {
    marginTop: 20,
    background: '#E5E7E9',
    borderRadius: 8,
    padding: '10px 5px',
  },
  keyButton: {
    fontSize: '25px !important',
    fontFamily: 'SF Pro Display, sans-serif !important',
    fontWeight: '400 !important',
    color: '#0B3660 !important',
    padding: '0 !important',
    borderRadius: '8px !important',
    width: '100% !important',
    height: '60px !important',
    margin: '3px auto !important',
    minWidth: 'unset !important',
    background: '#FCFCFE !important',
    boxShadow: '0px 1px 0px 0px rgba(137, 138, 141, 1) !important',
    transition: 'all 0.15s ease-in-out !important',
    '& .MuiButton-label': {
      color: '#0B3660 !important',
      fontSize: '25px !important',
      fontFamily: 'SF Pro Display, sans-serif !important',
      fontWeight: '400 !important',
    },
    '&:hover': {
      background: '#EBEBEB !important',
      transform: 'translateY(-1px) !important',
    },
    '&:active': {
      transform: 'translateY(0) !important',
      boxShadow: '0px 0px 0px 0px rgba(137, 138, 141, 1) !important',
    }
  },
  keyWrapper: {
    padding: '0 3px !important',
  },
  input: {
    maxWidth: 'none !important',
    textAlign: 'left !important',
    fontSize: '16px !important',
    fontFamily: 'Inter, sans-serif !important',
    fontWeight: '500 !important',
    color: '#0B3660 !important',
    height: '56px !important',
    borderRadius: '8px !important',
    border: '1px solid rgba(0, 0, 0, 0.3) !important',
    paddingLeft: '50px !important',
    background: '#ffffff url("data:image/svg+xml,%3csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3cpath d=\'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z\' fill=\'%23999999\'/%3e%3c/svg%3e") no-repeat 16px center !important',
    backgroundSize: '24px 24px !important',
    '&::placeholder': {
      color: 'rgba(0, 0, 0, 0.4) !important',
      fontFamily: 'Inter, sans-serif !important',
      fontWeight: '500 !important',
      fontSize: '16px !important',
    }
  },
  backspace: {
    margin: '0 !important',
    height: '60px !important',
    padding: '18px 10px !important',
    minWidth: 'unset !important',
    borderRadius: '8px !important',
    background: '#FCFCFE !important',
    boxShadow: '0px 1px 0px 0px rgba(137, 138, 141, 1) !important',
    color: '#000000 !important',
    '& svg': {
      color: '#000000 !important',
    },
    '&:hover': {
      background: '#EBEBEB !important',
      transform: 'translateY(-1px) !important',
    },
  },
  buttonWrapper: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    width: '100%'
  }
}